import {Injectable} from '@angular/core';
import {Observable, of} from 'rxjs';
import {delay} from 'rxjs/operators';
import {ExternalForecastComparison} from './external-forecast.model';
import {comparisonScenario} from './testing/comparison.fixture';

const MOCK_LATENCY_MS = 600;

@Injectable({providedIn: 'root'})
export class ExternalForecastService {

  /**
   * Mock API: serves the fixture until the plan-manager endpoint
   * (appSettings.resourceLocations.externalForecast) is available. Safe to call unconditionally
   * because the feature is behind the esp-external-forecast toggle.
   */
  getExternalForecast(planOid: string): Observable<ExternalForecastComparison> {
    return of({...comparisonScenario("ok", planOid), snapshotAt: new Date().toISOString()})
      .pipe(delay(MOCK_LATENCY_MS));
  }
}
